var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDateStartFilled = function SvgDateStartFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M8 1.25a.75.75 0 0 1 .75.75v1.25h6.5V2a.75.75 0 0 1 1.5 0v1.25H19A2.75 2.75 0 0 1 21.75 6v13A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19V6A2.75 2.75 0 0 1 5 3.25h2.25V2A.75.75 0 0 1 8 1.25Zm-.75 3.5H5c-.69 0-1.25.56-1.25 1.25v2.25h16.5V6c0-.69-.56-1.25-1.25-1.25h-2.25V6a.75.75 0 0 1-1.5 0V4.75h-6.5V6a.75.75 0 0 1-1.5 0V4.75Zm13 5H3.75V19c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V9.75Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "M5 4.75h2.25V6a.75.75 0 0 0 1.5 0V4.75h6.5V6a.75.75 0 0 0 1.5 0V4.75H19c.69 0 1.25.56 1.25 1.25v2.25H3.75V6c0-.69.56-1.25 1.25-1.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M13.538 13.538a5.25 5.25 0 1 1 7.424 7.424 5.25 5.25 0 0 1-7.424-7.424Zm2.72 6.258a.5.5 0 0 1-.758-.43v-4.233a.5.5 0 0 1 .757-.429l3.528 2.117a.5.5 0 0 1 0 .858l-3.528 2.117Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDateStartFilled);
export default ForwardRef;